import endOfYear from 'owa-date-utc-fn/lib/endOfYear';
import tzDateFn from './tzDateFn';
import type { OwaDate } from '../schema';

/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
 *	> Function tzDateFn called at module scope is not allowed. This may cause unwanted side effects. */
export default tzDateFn(endOfYear) as (date: OwaDate) => OwaDate;
